import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";


import { orderDefault } from "../../shared/utility";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CartViewModel(setCart, setOrderDetails, logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const createOrderFromCart = async function (payload) {
    let callResult = await makePostApiCall(`createOrder`, {
      customer_id: payload.orderDetails.customer_id,
      customer_group_id: payload.orderDetails.customer_group_id,
      po_number: payload.orderDetails.po_number,
      expected_date: payload.orderDetails.expected_date,
      notes: payload.notes,
      products: payload.cart,
    });
    if (callResult.success) {
      window.location = `/orders/${callResult.data.id}`;

      setCart([]);
      setOrderDetails(orderDefault);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    createOrderFromCart,
  };
}
